import { combineReducers } from 'redux';

// Reducers
import stepper from './stepper';
import verificacion from './verificacion';
import paises from './paises';
import parametros from './parametros';
import loaders from './ui_loaders';
import casoBorde from './casoBordes';
import oferta from './oferta';
import sucursal from './sucursal';
import contratos from './contratos';
import encuesta from './encuesta';

const reducers = combineReducers({
  entities: combineReducers({
    stepper,
    verificacion,
    paises,
    parametros,
    oferta,
    sucursal,
    contratos,
    encuesta
  }),
  ui: combineReducers({
    loaders,
    casoBorde
  }),
});

export default reducers;
